module.exports = __webpack_public_path__ + "assets/avatar.7c7fd5531480a23b64c159f31bbc1edb1d7c6e429e4bcc8b22802d9838407427.png";